import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  AppBar,
  Box,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Toolbar,
  Typography,
} from '@mui/material';
import MenuIcon from '@material-ui/icons/Menu';
import TpcLogoCondensed from '../../components/nav/svgs/TpcLogoCondensed';

interface MobileLayoutProps {
  children: React.ReactNode;
}

const MobileLayout: React.FC<MobileLayoutProps> = ({ children }) => {
  const history = useHistory();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const navigate = (path: string) => {
    setDrawerOpen(false);
    history.push(path);
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#F5F5F5' }}>
      <AppBar position="static" sx={{ bgcolor: 'common.black' }}>
        <Toolbar>
          <Box sx={{ flexGrow: 1 }}>
            <TpcLogoCondensed />
          </Box>
          <IconButton edge="end" color="inherit" onClick={() => setDrawerOpen(true)}>
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Drawer anchor="right" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        <List sx={{ width: 220 }}>
          <ListItem button onClick={() => navigate('/mobile')}>
            <ListItemText primary="Home" />
          </ListItem>
          <ListItem>
            <Typography variant="overline" color="text.secondary" sx={{ fontWeight: 600 }}>
              Fulfillment
            </Typography>
          </ListItem>
          <ListItem button onClick={() => navigate('/mobile/pick')} sx={{ pl: 3 }}>
            <ListItemText primary="Run Pick Wave" />
          </ListItem>
        </List>
      </Drawer>
      <Box sx={{ maxWidth: 480, margin: '0 auto', p: 2 }}>{children}</Box>
    </Box>
  );
};

export default MobileLayout;
